import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TertiaryButton from "../../../../_utils/CommonButtons/TertiaryButton";

import { ownerAccountsViewAll } from "../../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getAllBeneficiaryAccounts } from "../../../../../redux/features/accounts/beneficiaryAccount/index.js";
import { getAllInternalAccounts } from "../../../../../redux/features/accounts/internalAccount/index.js";
import { beneficiaryTransactionsViewAll } from "../../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import { internalTransactionsViewAll } from "../../../../../redux/features/transactions/internalTransactions/index.js";
import { getUsers } from "../../../../../redux/features/Settings/Management/Users";
import SingleSelectDropDownComponent from "../../../../_utils/CommonDropdown/SingleSelectDropdown/index.jsx";
import SingleSelectDropDownComponentWithIcon from "../../../../_utils/CommonDropdown/SingleSelectDropdownWithIcon/index.jsx";
import { getAllFieldForceAccount } from "../../../../../redux/features/accounts/fieldForceAccount/index.js";
import { getAllfieldForceTxn } from "../../../../../redux/features/fieldForceTransaction/index.js";
import ICONS from "../../../../../assets/Icons/index.js";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider.js";
import globalText from "../../../../../utils/globalText.js";

const daysOptions = [
  { name: "Last 7 days", value: "last 7 days" },
  { name: "Last 28 days", value: "last 28 days" },
];

const amountOptions = [
  { name: "Absolute (amount)", value: "" },
  { name: "Amount in lakhs", value: "Lakhs" },
  { name: "Amount in crores", value: "Crores" },
  { name: "Amount in millions", value: "Millions" },
  { name: "Amount in billions", value: "Billions" },
];

const GraphHeader = ({
  noData,
  handlingOptionsRequired,
  titleText,
  flowType,
  flow,
  hideTitle,
  autoFetch,
  isAddedToHome,
  toggleAddedToHome,
}) => {
  const dispatch = useDispatch();

  const [optionType, setOptionType] = useState("");

  // states

  const [selectedDays, setSelectedDays] = useState(
    daysOptions[GlobalConfiguration?.lengthCheckZero],
  );

  const [selectedAmount, setSelectedAmount] = useState(
    amountOptions[GlobalConfiguration?.lengthCheckZero],
  );

  const [accountOptions, setAccountOptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState("");
  const disableInternal = autoFetch === true && flow === "bene";
  const disableBene = autoFetch === true && flow === "internal";
  const disableFieldForce = autoFetch === true && flow === "fieldForce";
  const services = useSelector((state) => state.refreshToken.services);
  const globalStatisticsService = services?.includes("VStatistics"); // Global service for statistics.

  const txnOptionsArray = disableInternal
    ? [{ name: "Beneficiary transactions", value: "bene" }]
    : disableBene
      ? [{ name: "Internal transactions", value: "internal" }]
      : disableFieldForce
        ? [{ name: "Field Force transactions", value: "fieldForce" }]
        : [
            { name: "Beneficiary transactions", value: "bene" },
            { name: "Internal transactions", value: "internal" },
            // { name: "Field Force transactions", value: "fieldForce" },
            // { name: "Reimbursement transactions", value: "reimbursement" },
          ];

  const [selectedTxnOption, setSelectedTxnOption] = useState(
    txnOptionsArray[0],
  );

  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("All employees");

  const [labelsOptions, setLabelsOptions] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState(null);

  const [favLoading, setfavLoading] = useState(false);
  const [empLoading, setEmpLoading] = useState(false);
  const [labelsLoading, setLabelsLoading] = useState(false);

  // propagate selected options
  useEffect(() => {
    handlingOptionsRequired.forEach((opt) => {
      setOptionType(opt.type);
      if (opt.type === "days") opt.setterState(selectedDays.value);
      if (opt.type === "amounts") opt.setterState(selectedAmount.value);
      if (opt.type === "allAccounts" && selectedAccount) {
        opt.setterState(selectedAccount.value);
      }
      if (opt.type === "favouriteAccounts" && selectedAccount) {
        opt.setterState(selectedAccount);
      }
      if (opt.type === "txnOption") {
        opt.setterState(selectedTxnOption.value);
      }
      if (opt.type === "employees" && selectedEmployee) {
        opt.setterState(selectedEmployee.value);
      }
      if (opt.type === "labels" && selectedLabels) {
        opt.setterState(selectedLabels.value);
      }
    });
  }, [
    selectedDays,

    selectedAmount,

    selectedAccount,
    selectedTxnOption,

    selectedEmployee,
    handlingOptionsRequired,
  ]);

  // fetch accounts
  useEffect(() => {
    const fetchAccounts = async () => {
      setfavLoading(true);

      const firstPage = await dispatch(
        optionType === "favouriteAccounts"
          ? ownerAccountsViewAll({
              favourite: "Y",
              connected_banking: "Y",
              page_no: GlobalConfiguration?.lengthCheckOne,
              page_size: 100,
            })
          : ownerAccountsViewAll({
              page_no: GlobalConfiguration?.lengthCheckOne,
              connected_banking: "Y",
              page_size: 100,
            }),
      );

      if (
        firstPage?.payload?.status &&
        firstPage.payload.owner_accounts?.length
      ) {
        const totalPages = firstPage.payload.title?.total_pages;

        let allAccounts = [...firstPage.payload.owner_accounts];

        // fetch remaining pages if any
        if (totalPages > GlobalConfiguration?.lengthCheckOne) {
          for (
            let i = GlobalConfiguration?.lengthCheckTwo;
            i <= totalPages;
            i++
          ) {
            const res = await dispatch(
              optionType === "favouriteAccounts"
                ? ownerAccountsViewAll({
                    favourite: "Y",
                    page_no: i,
                    connected_banking: "Y",
                    page_size: 100,
                  })
                : ownerAccountsViewAll({
                    page_no: i,
                    connected_banking: "Y",
                    page_size: 100,
                  }),
            );

            if (res?.payload?.status && res.payload.owner_accounts?.length) {
              allAccounts = [...allAccounts, ...res.payload.owner_accounts];
            } else {
              console.error(`Failed to fetch page ${i}`);
            }
          }
        }

        const allOwnerAcId = allAccounts.map((val) => val.id);

        const options = allAccounts.map((val) => ({
          name: val.bank_acc_no,
          label: val.bank_acc_no,
          icon: ICONS?.FAVOURITE_FILLED,
          value: [val.id],
        }));

        // first option is "All accounts"

        let formattedOptions;

        if (optionType === "allAccounts") {
          formattedOptions = [
            {
              name: "All owner accounts",
              value: allOwnerAcId, // same as owner accounts example
            },
            ...options,
          ];
        } else {
          formattedOptions = options;
        }
        setAccountOptions(formattedOptions);
        setSelectedAccount(
          formattedOptions[GlobalConfiguration?.lengthCheckZero],
        ); // default first
      }
      setfavLoading(false);
    };

    if (optionType === "favouriteAccounts" || optionType === "allAccounts")
      fetchAccounts();
  }, [dispatch, optionType]);

  // fetch labels

  useEffect(() => {
    const fetchLabels = async () => {
      setLabelsLoading(true);

      const response =
        flowType === "beneAccount"
          ? await dispatch(getAllBeneficiaryAccounts({}))
          : flowType === "intAccount"
            ? await dispatch(getAllInternalAccounts({}))
            : flowType === "fieldForceAccount"
              ? await dispatch(getAllFieldForceAccount({}))
              : flowType === "beneTxn"
                ? await dispatch(beneficiaryTransactionsViewAll({}))
                : flowType === "intTxn"
                  ? await dispatch(internalTransactionsViewAll({}))
                  : flowType === "fieldForceTxn"
                    ? await dispatch(getAllfieldForceTxn({}))
                    : null;

      if (
        response?.payload?.status &&
        response.payload.summary.available_labels
      ) {
        let allLabelsOptions = [];
        response.payload.summary.available_labels.map((val) =>
          allLabelsOptions.push(val.id),
        );

        const options = response.payload.summary.available_labels.map(
          (val) => ({
            name: val,
            value: val,
          }),
        );

        let formattedOptions = [];
        formattedOptions = [
          {
            name: "All labels",
            value: allLabelsOptions.toString(),
          },
          ...options,
        ];

        setLabelsOptions(formattedOptions);
        setSelectedLabels(
          formattedOptions[GlobalConfiguration?.lengthCheckZero],
        ); // default first
      }
      setLabelsLoading(false);
    };

    fetchLabels();
  }, [dispatch, optionType]);

  //fetch employees
  useEffect(() => {
    const fetchUsers = async () => {
      setEmpLoading(true);

      try {
        // fetch the first page
        const firstPage = await dispatch(
          getUsers({
            page_no: GlobalConfiguration?.lengthCheckOne,
            page_size: 100,
          }),
        );

        if (firstPage?.payload?.status && firstPage.payload.employees?.length) {
          const totalPages = firstPage.payload.title?.total_pages;

          let allEmployees = [...firstPage.payload.employees];

          // fetch remaining pages if any
          if (totalPages > GlobalConfiguration?.lengthCheckOne) {
            for (
              let i = GlobalConfiguration?.lengthCheckTwo;
              i <= totalPages;
              i++
            ) {
              const res = await dispatch(
                getUsers({ page_no: i, page_size: 100 }),
              );

              if (res?.payload?.status && res.payload.employees?.length) {
                allEmployees = [...allEmployees, ...res.payload.employees];
              } else {
                console.error(`Failed to fetch page ${i}`);
              }
            }
          }

          const allEmployeeIds = allEmployees.map((val) => val.id);

          const options = allEmployees.map((val) => ({
            name: `${val?.first_name || ""} ${val?.last_name || ""}`,
            value: val.id,
          }));

          // first option is "All employees"
          const formattedOptions = [
            {
              name: "All employees",
              value: allEmployeeIds, // same as owner accounts example
            },
            ...options,
          ];

          setEmployeeOptions(formattedOptions);
          setSelectedEmployee(
            formattedOptions[GlobalConfiguration?.lengthCheckZero],
          ); // default first
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }

      setEmpLoading(false);
    };

    if (optionType === "employees") fetchUsers();
  }, [dispatch, optionType]);
  useEffect(() => {
    if (disableInternal) {
      setSelectedTxnOption({ name: "Beneficiary transactions", value: "bene" });
      handlingOptionsRequired
        ?.find((o) => o.type === "txnOption")
        ?.setterState("bene");
    } else if (disableBene) {
      setSelectedTxnOption({
        name: "Internal transactions",
        value: "internal",
      });
      handlingOptionsRequired
        ?.find((o) => o.type === "txnOption")
        ?.setterState(selectedTxnOption.value);
    } else if (disableFieldForce) {
      setSelectedTxnOption({
        name: "Field Force transactions",
        value: "fieldForce",
      });
      handlingOptionsRequired
        ?.find((o) => o.type === "txnOption")
        ?.setterState(selectedTxnOption.value);
    }
  }, [
    disableInternal,
    disableBene,
    disableFieldForce,
    handlingOptionsRequired,
  ]);

  return (
    <div className="flex flex-col w-width-full h-auto">
      {/* Header Top Div */}

      <div
        className={`flex justify-between items-center pl-padding-md rounded-t-border-radius-md h-height-full relative Qsmd:bg-primary-card bg-primary-nav`}
      >
        {!hideTitle && (
          <div className="justify-start flex items-center gap-gap-sm w-width-lg py-padding-sm">
            <img
              className="w-icon-sm h-icon-sm"
              src={ICONS?.STATISTICS}
              alt="Statistics"
            />
            <div className="text-font-sm text-text-primary font-semibold">
              {titleText}
            </div>
          </div>
        )}
        {!autoFetch && !hideTitle && toggleAddedToHome && (
          // NOTE: Remove `toggleAddedToHome` from the above condition once all statistics APIs and UI are ready.
          <>
            <div className="justify-end h-[-webkit-fill-available] relative hidden Qsmd:block ">
              <TertiaryButton
                btnText={
                  <p className="Qsmd:block text-text-primary font-normal text-font-xs  hidden">
                    {isAddedToHome ? "Remove from home" : "Add to home"}
                  </p>
                }
                handleFunction={() => {
                  if (toggleAddedToHome) {
                    toggleAddedToHome(!isAddedToHome);
                  }
                }}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-act)"
                isLoading={false}
                borderRadius={true}
                borderRadiusTopRight={true}
                icon={
                  isAddedToHome
                    ? ICONS?.HOME_UNSELECTED
                    : ICONS?.HOME_UNSELECTED_OUTLINE
                }
                hoverOption="white"
                heightFullRequired={true}
              />
            </div>
            <div className="Qsmd:hidden justify-end h-[-webkit-fill-available] relative">
              <TertiaryButton
                btnText={
                  <p className="Qsmd:block text-text-primary font-normal text-font-xs  hidden">
                    {isAddedToHome ? "Remove from home" : "Add to home"}
                  </p>
                }
                handleFunction={() => {
                  if (toggleAddedToHome) {
                    toggleAddedToHome(!isAddedToHome);
                  }
                }}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav-act)"
                isLoading={false}
                borderRadius={true}
                borderRadiusTopRight={true}
                icon={
                  isAddedToHome
                    ? ICONS?.HOME_UNSELECTED
                    : ICONS?.HOME_UNSELECTED_OUTLINE
                }
                hoverOption="white"
                heightFullRequired={true}
              />
            </div>
          </>
        )}
      </div>

      {!noData && (
        <div className="flex Qsmd:flex-row flex-col w-width-full z-z-index-dropdown statistic-mobile-dropdown px-padding-md pt-padding-sm pb-padding-md gap-gap-sm Qsmd:p-padding-base Qsmd:gap-gap-base">
          {handlingOptionsRequired?.map((val) => {
            if (val.type === "days")
              return (
                <div className="flex flex-col flex-1 gap-gap-xs">
                  <p className="Qsmd:hidden block text-text-secondary text-font-xs font-semibold ">
                    Frequency
                  </p>
                  <div className="flex flex-1">
                    <SingleSelectDropDownComponent
                      options={daysOptions}
                      isOpen={false}
                      selected={selectedDays.value}
                      setSelected={setSelectedDays}
                      disabled={!globalStatisticsService}
                      placeholder={globalText?.LAST_7_DAYS.toLowerCase()}
                      type="small"
                      isStatistic={true}
                    />
                  </div>
                </div>
              );

            if (val.type === "amounts")
              return (
                <div className="flex flex-col flex-1 Qsmd:bg-primary-act Qsmd:border-l-border border-primary-bg gap-gap-xs">
                  <p className="Qsmd:hidden block text-text-secondary text-font-xs font-semibold ">
                    Amount
                  </p>
                  <div className="flex flex-1">
                    <SingleSelectDropDownComponent
                      options={amountOptions}
                      isOpen={false}
                      selected={selectedAmount.value}
                      setSelected={setSelectedAmount}
                      disabled={!globalStatisticsService}
                      placeholder="Absolute (amount)"
                      type="small"
                      isStatistic={true}
                    />
                  </div>
                </div>
              );

            if (val.type === "allAccounts")
              return (
                <div className="flex flex-col flex-1 Qsmd:bg-primary-act Qsmd:border-l-border border-primary-bg gap-gap-xs">
                  <p className="Qsmd:hidden block text-text-secondary text-font-xs font-semibold ">
                    Owner account
                  </p>
                  <div className="flex flex-1">
                    <SingleSelectDropDownComponent
                      options={accountOptions}
                      isOpen={false}
                      selected={selectedAccount.value}
                      statisticDisplayName={
                        selectedAccount.name || "All owner accounts"
                      }
                      setSelected={setSelectedAccount}
                      disabled={!globalStatisticsService}
                      placeholder="All owner accounts"
                      type="small"
                      isStatistic={true}
                    />
                  </div>
                </div>
              );
            if (val.type === "favouriteAccounts")
              return (
                <div className="flex flex-col gap-gap-xs flex-1 Qsmd:bg-primary-act Qsmd:border-l-border border-primary-bg">
                  <p className="Qsmd:hidden block text-text-secondary text-font-xs font-semibold ">
                    Favourited owner accounts
                  </p>
                  <div className="flex flex-1">
                    <SingleSelectDropDownComponentWithIcon
                      options={accountOptions}
                      isOpen={false}
                      selected={selectedAccount}
                      setSelected={setSelectedAccount}
                      disabled={favLoading || !globalStatisticsService}
                      placeholder="All owner accounts"
                      type="small"
                      isStatistic={true}
                    />
                  </div>
                </div>
              );

            if (val.type === "txnOption")
              return (
                <div
                  className={`flex flex-col flex-1 gap-gap-xs  Qsmd:border-l-border border-primary-bg ${globalStatisticsService ? "Qsmd:bg-primary-act" : ""}`}
                >
                  <p className="Qsmd:hidden block text-text-secondary text-font-xs font-semibold ">
                    Transaction type
                  </p>
                  <div className="flex flex-1">
                    <SingleSelectDropDownComponent
                      options={txnOptionsArray}
                      isOpen={false}
                      selected={selectedTxnOption.value}
                      statisticDisplayName={selectedTxnOption.name}
                      setSelected={setSelectedTxnOption}
                      placeholder="Beneficary transactions"
                      type="small"
                      disabled={
                        disableInternal ||
                        disableBene ||
                        disableFieldForce ||
                        !globalStatisticsService
                      }
                      isStatistic={true}
                    />
                  </div>
                </div>
              );
            if (val.type === "employees")
              return (
                <div className="flex flex-col flex-1 gap-gap-xs Qsmd:bg-primary-act Qsmd:border-l-border border-primary-bg">
                  <p className="Qsmd:hidden block text-text-secondary text-font-xs font-semibold ">
                    Employee
                  </p>
                  <div className="flex flex-1">
                    <SingleSelectDropDownComponent
                      options={employeeOptions}
                      isOpen={false}
                      selected={selectedEmployee.value}
                      statisticDisplayName={
                        selectedEmployee.name || "All employees"
                      }
                      setSelected={setSelectedEmployee}
                      disabled={empLoading || !globalStatisticsService}
                      placeholder="All employee"
                      type="small"
                      isStatistic={true}
                    />
                  </div>
                </div>
              );

            if (val.type === "labels")
              return (
                <div className="flex flex-col flex-1 Qsmd:bg-primary-act Qsmd:border-r-border border-b-border Qsmd:border-b-border-base border-primary-bg Qmd:max-w-max_width-md">
                  <p className="Qsmd:hidden block text-text-secondary text-font-xs font-semibold ">
                    Label
                  </p>
                  <div className="flex flex-1">
                    <SingleSelectDropDownComponent
                      options={labelsOptions}
                      isOpen={false}
                      selected={selectedLabels.value}
                      setSelected={setSelectedLabels}
                      disabled={labelsLoading || !globalStatisticsService}
                      placeholder="All employee"
                      type="small"
                      isStatistic={true}
                    />
                  </div>
                </div>
              );

            return null;
          })}
        </div>
      )}
    </div>
  );
};

export default GraphHeader;
